import { Redirect, useRouteMatch } from "react-router";
import { BookingRequests } from "../BookingRequest/booking-requests.page";
import { OrderRequestManagement } from "./OrderRequests/OrderRequestManagement";
import { ServiceItemManagement } from "./ServiceItemManagement.page";

const ServiceManagementPage: React.FC = () => {
  const { params } = useRouteMatch<{ dest: string; subDest?: string }>();

  switch (params.subDest) {
    case "management":
      return <ServiceItemManagement />;
    case "bookings":
      return <BookingRequests />;
    case "orders":
      return <OrderRequestManagement />;
    default:
      return <Redirect to={"/"} />;
  }
};

export default ServiceManagementPage;
